import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import Select from "react-select";

import { NextStepButton, TabNavigation, Logo } from "components";
import { TAB_3A_UPDATE_SELECTED_COUNTRIES, MOVE_TAB } from "actions";

import countries from "./countries";

const SelectContainer = styled.div.attrs({
  className: "select_container"
})`
  .Select {
    .Select-menu-outer {
      .Select-menu {
        .Select-option {
          background: transparent;
          &:hover,
          &:selected,
          &:active,
          &:focus {
            background: ${props => props.bg};
          }
        }
      }
    }
  }
`;

class Tab3A extends Component {
  state = {
    error: false
  };
  selectCountry = options => {
    this.props.updateCountries(options);
  };
  submit = () => {
    if (this.props.countries.length === 0) {
      this.setState({ error: true });
      return;
    }

    this.props.moveToNextTab();
  };
  render() {
    const props = this.props;
    const state = this.state;
    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div>
              <h2 className="link_checkbox_container--title">{props.domain.Strings.tab3ATitle}</h2>
              <SelectContainer bg={props.domainBaseColour + "22"}>
                <Select
                  style={{
                    outline: "none",
                    color: "transparent",
                    boxShadow: "none"
                  }}
                  clearable={false}
                  className={state.error ? "has-error" : ""}
                  placeholder={props.domain.Strings.tab3ACountriesPlaceholder}
                  searchable={true}
                  value={props.countries}
                  multi={true}
                  onChange={this.selectCountry}
                  multiple
                  options={countries}
                />
              </SelectContainer>
              <NextStepButton text={props.domain.Strings.tab3ANextBtn} onClick={this.submit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateCountries: countries => dispatch({ type: TAB_3A_UPDATE_SELECTED_COUNTRIES, countries }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab3A);
